export const BRAND_NAME = "PlutoEdu";

export const USER_TYPE = {
  Admin: "Admin",
  Faculty: "Faculty",
  Applicant: "Applicant",
};

export const VIEW_PROFILE_SECTIONS = {
  personalDetails: "personalDetails",
  education: "education",
  experience: "experience",
  publication: "publication",
  grant: "grant",
  recognition: "recognition",
  researchSummary: "researchSummary",
  aboutMe: "aboutme",
  onlineProfiles: "onlineProfiles",
  resume: "resume",
  skills: "skills",
  careerInterest: "careerInterest",
  photoURL: "photoURL",
  coverimageURL: "coverimageURL",
  languages: "languages",
};

export const GENDER_OPTIONS = [
  { value: "male", label: "common.label.male" },
  { value: "female", label: "common.label.female" },
  { value: "other", label: "common.label.other" },
  { value: "preferNotToSay", label: "common.label.preferNotToSay" },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  { value: "fullTime", label: "common.label.fullTime" },
  { value: "partTime", label: "common.label.partTime" },
  { value: "internship", label: "common.label.internship" },
  { value: "contract", label: "common.label.contract" },
  { value: "freelance", label: "common.label.freelance" },
  { value: "temporary", label: "common.label.temporary" },
  { value: "volunteer", label: "common.label.volunteer" },
];

export const COLOR_SETTINGS = [
  "#BD97EA",
  "#D66D6D",
  "#E38D3E",
  "#6396DA",
  "#59AB7F",
  "#3EACC5",
];

export const DESIGN_TYPE_LIST = [
  {
    key: "none",
    name: "None",
  },
  {
    key: "user",
    name: "User",
  },
  {
    key: "rating",
    name: "Rating",
  },
  {
    key: "hyperlink",
    name: "Hyperlink",
  },
  {
    key: "status",
    name: "Status",
  },
  {
    key: "assignee",
    name: "Assignee",
  },
  {
    key: "comment",
    name: "Comment",
  },
  {
    key: "image",
    name: "Image",
  },
  {
    key: "tag",
    name: "Tag",
  },
  {
    key: "attachment",
    name: "Attachment",
  },
];

export const FEILD_TYPE_LIST = [
  {
    key: "select",
    name: "Select",
  },
  {
    key: "text",
    name: "Text",
  },
  {
    key: "number",
    name: "Number",
  },
  {
    key: "date",
    name: "Date",
  },
];

export const AUTH_TOKEN = "TOKEN";
export const REFRESH_TOKEN = "REFRESH";
export const DEFAULT_PAGE_SIZE = 20;

export const MIN_YEAR = 1800;
export const MIN_SALARY = 1;
export const MAX_SALARY = 9999999;
export const MIN_COMPANY_SIZE = 1;
export const MAX_COMPANY_SIZE = 9999999;

export const ISO_DATE = new Date().toISOString();
export const CURRENT_YEAR = new Date().getFullYear();

export const DEFAULT_MODULE_TYPE = {
  userDocuments: "userDocuments",
  portfolioDocument: "portfolioDocument",
  email: "email",
  emailTemplate: "emailTemplate",
  chat: "chat",
  profilePicture: "profilePicture",
  coverPicture: "coverPicture",
  coverImage: "coverImage",
  universityLogo: "universityLogo",
  formBackgroundImage: "formBackgroundImage",
  formBuilder: "formBuilder",
  recommendation: "recommendation",
  event: "event",
};

export const FILE_TYPE = {
  image: "image",
  video: "video",
  document: "document",
};

export const DEFAULT_DOCUMENT_TYPE = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const IMAGE_TYPES = [
  "png",
  "PNG",
  "jpg",
  "jpeg",
  "JPG",
  "JPEG",
  "gif",
  "GIF",
];

export const VIDEO_TYPES = ['webm; codecs="opus,vp8"', "mp4"];

export const DOCUMENT_TYPE_PDF_ONLY = ["pdf"];
export const DOCUMENT_TYPE_DOC_ONLY = [
  "vnd.openxmlformats-officedocument.wordprocessingml.document",
  "msword",
];
export const DOCUMENT_TYPE_XLS_ONLY = [
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "vnd.ms-excel",
];
export const DOCUMENT_TYPE_PPT_ONLY = [
  "vnd.openxmlformats-officedocument.presentationml.presentation",
  "vnd.ms-powerpoint",
];

export const DOCUMENT_TYPES = [
  ...DOCUMENT_TYPE_PDF_ONLY,
  ...DOCUMENT_TYPE_DOC_ONLY,
  ...DOCUMENT_TYPE_XLS_ONLY,
  ...DOCUMENT_TYPE_PPT_ONLY,
];

export const CHATS_FILE_TYPES = [
  ...IMAGE_TYPES,
  ...DOCUMENT_TYPE_PDF_ONLY,
  ...DOCUMENT_TYPE_DOC_ONLY,
  ...DOCUMENT_TYPE_XLS_ONLY,
  ...DOCUMENT_TYPE_PPT_ONLY,
];

export const FORMBUILDER_FILE_TYPES = [
  ...IMAGE_TYPES,
  ...DOCUMENT_TYPE_PDF_ONLY,
  ...DOCUMENT_TYPE_DOC_ONLY,
  ...DOCUMENT_TYPE_XLS_ONLY,
  ...DOCUMENT_TYPE_PPT_ONLY,
];

export const passwordRules = [
  "Cannot contain your name or email address",
  "At least 8 characters",
  "At least one uppercase letter",
  "At least one lowercase letter",
  "At least one number",
  "At least one special character",
];

export const SOCIAL_LINKS = {
  twitter: "https://x.com/PlutoEducation",
  facebook: "https://www.facebook.com/profile.php?id=61552186622293",
  instagram: "https://www.instagram.com/pluto_edu/",
  linkedin: "https://www.linkedin.com/company/plutotask/about/",
  blog: "https://blog.plutoedu.com/",
};

export const JOB_TYPES = [
  "Full-time",
  "Part-time",
  "Contract",
  "Temporary",
  "Internship",
  "Apprenticeship",
  "Freelance",
  "Volunteer",
];

export const EXPERIENCE_LEVELS = [
  { label: "0 - 1 years", value: "0-1" },
  { label: "1 - 3 years", value: "1-3" },
  { label: "3 - 5 years", value: "3-5" },
  { label: "5 - 7 years", value: "5-7" },
  { label: "7 - 10 years", value: "7-10" },
  { label: "10 - 15 years", value: "10-15" },
  { label: "15+ years", value: "15+" },
];

export const SPLIT_CHARACTER = "##";